import React, { useEffect, useState } from "react";

function AnimatedHiddenTextInput({
  value,
  onChange = null,
  id,
  isFocused = false,
  label,
  isDisabled = false,
}) {
  const [isActive, setActive] = useState(isFocused);
  const [textValue, setTextValue] = useState(value);
  const [inputType, setInputType] = useState("text");

  const focused = () => {
    setInputType("text");
    setActive(true);
  };
  const unFocused = () => {
    setInputType("password");
    setActive(false);
  };
  const handleChange = (e) => {
    //TODO: Check if redundant
    setTextValue(e.target.value);
    if (onChange) {
      onChange(e);
    }
  };

  useEffect(() => {
    setTextValue(value);
  }, [value]);

  return (
    <div
      className={
        isActive || textValue ? "field_group field_lbl_active" : "field_group"
      }
    >
      <label className="field_lbl">{label}</label>
      <input
        type={inputType}
        className="field_input"
        placeholder=""
        value={textValue}
        autoFocus={isActive}
        onFocus={focused}
        onBlur={unFocused}
        onChange={handleChange}
        id={id}
        disabled={isDisabled}
      />
      <span className="icon" id="patientId"></span>
    </div>
  );
}

export default AnimatedHiddenTextInput;
